import { useState } from "react";

const UploadImages: React.FunctionComponent<{ OnUploadImages: any, name: string }> = (props) => {


    function getRandomSixDigitNumber(): number {
        return Math.floor(100000 + Math.random() * 900000);
    }

    const processFiles = async (files: any[]) => {
        const oversized: any[] = [];
        const validFiles: any[] = [];
        let hasOversized = false;

        for (let file of files) {
            if (file.size > 10 * 1024 * 1024) {
                hasOversized = true;
                oversized.push(file);
            } else {
                validFiles.push(file);
            }
        }

        setTimeout(() => {
            handleValidFileProcessing(validFiles, hasOversized);
        }, 0);
    };

    const handleValidFileProcessing = async (files: any[], value: boolean) => {
        const processedImages: any[] = [];

        for (let file of files) {
            const reader = new FileReader();
            const result = await new Promise<string>((resolve) => {
                reader.onload = () => resolve(reader.result as string);
                reader.readAsDataURL(file);
            });
            const ext = file.type.split('/')[1];
            processedImages.push({ id: getRandomSixDigitNumber(), src: result, ext ,toAnalyze :false});
        }
        props.OnUploadImages(processedImages, value);
    };

    const HandleChangeUpload = async (event: any) => {
        const files = Array.from(event.target.files);
        await processFiles(files);
    };



    return (
        <div className="upload-xml">
            < label className="form__container padd-20" id="upload-container">
                <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="40" cy="40.5" r="40" fill="white" />
                    <path d="M34.9891 31.0375L34.5016 32.5H31C29.3453 32.5 28 33.8453 28 35.5V47.5C28 49.1547 29.3453 50.5 31 50.5H49C50.6547 50.5 52 49.1547 52 47.5V35.5C52 33.8453 50.6547 32.5 49 32.5H45.4984L45.0109 31.0375C44.7062 30.1188 43.8484 29.5 42.8781 29.5H37.1219C36.1516 29.5 35.2938 30.1188 34.9891 31.0375ZM40 46C37.5156 46 35.5 43.9844 35.5 41.5C35.5 39.0156 37.5156 37 40 37C42.4844 37 44.5 39.0156 44.5 41.5C44.5 43.9844 42.4844 46 40 46Z" fill="#7C3AED" />
                </svg>
                <p className="mt-3 para-onest-16 bold-600 color-9868F2">{props.name}</p>
                <input
                    className="form__file"
                    id="upload-files"
                    accept="image/jpeg, image/jpg, image/png, image/webp"
                    type="file"
                    multiple
                    onChange={HandleChangeUpload}
                />
            </label>
        </div >
    );
};

export default UploadImages;